import { render, staticRenderFns } from "./courseUsageSettings.vue?vue&type=template&id=2929aa2a&scoped=true"
import script from "./courseUsageSettings.vue?vue&type=script&lang=js"
export * from "./courseUsageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929aa2a",
  null
  
)

export default component.exports